import * as React from "react";
const SvgChevronDown = (props) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.29195 10.293C8.10514 10.4819 8.00037 10.7368 8.00037 11.0025C8.00037 11.2682 8.10514 11.5231 8.29195 11.712L11.2309 14.677C11.4489 14.892 11.7309 14.999 12.0099 14.999C12.2889 14.999 12.5659 14.892 12.7789 14.677L15.7089 11.722C15.8955 11.533 16.0001 11.2781 16.0001 11.0125C16.0001 10.7469 15.8955 10.492 15.7089 10.303C15.6171 10.2098 15.5077 10.1358 15.387 10.0853C15.2663 10.0348 15.1368 10.0088 15.0059 10.0088C14.8751 10.0088 14.7456 10.0348 14.6249 10.0853C14.5042 10.1358 14.3948 10.2098 14.3029 10.303L12.0049 12.62L9.69795 10.293C9.60591 10.2002 9.4964 10.1265 9.37574 10.0762C9.25508 10.0259 9.12566 10.0001 8.99495 10.0001C8.86423 10.0001 8.73481 10.0259 8.61415 10.0762C8.49349 10.1265 8.38398 10.2002 8.29195 10.293Z"
            fill="#42526E"
        />
    </svg>
);

export default SvgChevronDown;
